import VPageCourseReservationRecord from './index.vue';

export default {
  install: (Vue) => Vue.component('VPageCourseReservationRecord', VPageCourseReservationRecord),
};
